import cx from "classnames"
import * as React from "react"
import * as i18n from "tb-i18n"
import "tb-icons/lib/styles/tb-icons.css"
import { getGlobalConfig } from "../../../lib/global-config"
const styles = require("./card.styl")

interface Props {
    icon: string
    title: string
    detail: string
    link: string
}

export default class Card extends React.PureComponent<Props> {
    constructor(prop) {
        super(prop)
    }
    render() {
        const { icon, title, detail, link } = this.props
        const lang = getGlobalConfig().lang
        return (
            <a
                className={ cx(styles["project-type-card"], {
                    "large-height": lang === "en"
                }) }
                href={ link ? link : "javascript:void(0);" }
                target={ link ? "_blank" : "" }
            >
                <div className="project-type-card-image">
                    <div
                        className="project-type-card-image-icon"
                        style={{ backgroundImage: `url(${icon})` }}
                    />
                    <div className="project-type-card-image-tip">
                        {i18n.get("homepage.learnMore")}
                        <span className="icon icon-chevron-right" />
                    </div>
                </div>
                <div className="project-type-card-text">
                    <div className="project-type-card-text-title">{title}</div>
                    <div className="project-type-card-text-subtitle">
                        {detail}
                    </div>
                </div>
            </a>
        )
    }
}
